###
List of Users for project
###

# Libs
import _ from 'lodash'
import React from 'react'
import cnames from 'classnames'
import adopt from 'libs/adopt'

import { NotificationConsumer } from '../../application/components/NotificationManager'
import { UserInfoConsumer } from 'libs/userInfo'

# Renderable
import { div } from 'react-dom-factories'
Fragment = React.createFactory React.Fragment

import _ContentController from '@bevy/content-controller'
ContentController = React.createFactory _ContentController

import {InternalErrorState as _InternalErrorState} from 'components/ErrorDisplay'
InternalErrorState = React.createFactory _InternalErrorState


# Data
import {
	RootQuery
} from './data'

# Styles
import styles from './index.styl'

ITEMS_PER_PAGE = 100

DataLayer = adopt
	queries:
		rootQuery: ({projectSlug, sortKey, sortOrder, search}) ->
			query: RootQuery
			variables:
				projectSlug: projectSlug
				pagination:
					limit: ITEMS_PER_PAGE
				search: search
				# sort:
				# 	key: sortKey
				# 	order: if sortOrder is 'asc' then 'Ascending' else 'Descending'

# Content controller elements
import getToolbar from './elements/toolbar'
import getTable from './elements/table'
import getModals from './elements/modals'
import { USERS_COLUMNS } from './elements/columns'

export default class ProjectDocumentsView extends React.Component
	constructor: (props) ->
		super props
		@state =
			activeModal: null
			selected: []
			documentsTableColumns: @getInitialColumnsConfiguration()
			activeSearch: null
			sortKey: 'Name'
			sortOrder: 'asc'
			activeDocuments: []

	getToolbar: getToolbar
	getTable: getTable
	getModals: getModals

	getInitialColumnsConfiguration: () ->
		savedConfig = JSON.parse localStorage.getItem('tableView-projects-companies')
		if savedConfig?
			_.map savedConfig, (column) ->
				columnTemplate = _.find USERS_COLUMNS, {key: column.key}
				{
					...columnTemplate
					selected: column.selected
				}
		else USERS_COLUMNS

	changeTableConfiguration: (newTableConfig) =>
		if !newTableConfig? #restore default
			localStorage.removeItem 'tableView-projects-companies'
			@setState documentsTableColumns: USERS_COLUMNS
		else
			localStorage.setItem('tableView-projects-companies', JSON.stringify newTableConfig)
			@setState documentsTableColumns: newTableConfig

	handleItemsSelect: (ids) =>
		@setState
			selected: ids

	handleSortChange: (key, order) =>
		@setState
			sortKey: key
			sortOrder: order
			fetchedAll: false

	searchUpdate: ({data, selected}) ->
		(value) =>
			@setState
				activeSearch: value
				selected: null

	render: ->
		selected = @state.selected
		NotificationConsumer {}, ({ setNotification }) =>
			UserInfoConsumer {}, ({ ability, me, logAs }) =>
				DataLayer {
					setNotification
					search: @state.activeSearch
					sortKey: @state.sortKey
					sortOrder: @state.sortOrder
				}, (operations) =>
					if operations.rootQuery.error?
						InternalErrorState {}
					else
						members = if !operations.rootQuery.loading
								_.filter operations.rootQuery.data.users, (member) ->
									if member.__typename isnt 'Service'
										if member.id?
											{
												id: member.id
												...member
											}
							else
								[]

						Fragment {},
							ContentController
								pageId: 'users'
								'data-test-id': 'users-content'
								className: cnames styles.page
								toolbar: @getToolbar {members, selected, ability,	me, logAs}
								contentClassName: styles.content
								paneClassName: styles.pane
								filters:
									search: @searchUpdate {data: operations, selected}
								views:
									table: @getTable {
										items: members
										loading: operations.rootQuery.loading
										fetchMore: operations.rootQuery.fetchMore
										itemsCount:  if !operations.rootQuery.loading then _.size members
										columnsSetup: @state.documentsTableColumns
										changeTableConfiguration: @changeTableConfiguration
										selected
										onSelect: @handleItemsSelect
										onSortChange: @handleSortChange
										sortKey: @state.sortKey
										sortOrder: @state.sortOrder
										# getItemActions: (document) =>
										# 	{secondary} = @getToolbar {users, selected, ability,	me,	projectID}
										# 	secondary
									}

							@getModals {selected, members}

